__turbopack_context__.v({
  "customButtons": "partners-client-module__wzrPKq__customButtons",
  "customSubtitle": "partners-client-module__wzrPKq__customSubtitle",
  "customTextStack": "partners-client-module__wzrPKq__customTextStack",
  "customTitle": "partners-client-module__wzrPKq__customTitle",
});
